module.exports = __webpack_public_path__ + "static/img/weather_forecast_bg.234af2e2.svg";